.footer {
  display: flex;
  flex: 0 0 auto;
  min-height: 444px;
  margin-top: auto;
  width: 100%;

  h4,
  p {
    color: var(--pgm-sys-color-on-surface);
  }
}

.footerContent {
  background-color: var(--pgm-sys-color-surface-container);
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
}

.footerMain {
  box-sizing: border-box;
  display: grid;
  flex: 1 1 auto;
  gap: var(--pgm-sys-spacing-10);
  grid-template-columns: repeat(auto-fit, minmax(min(280px, 100%), 1fr));
  margin: 0 auto;
  max-width: 1440px;
  padding: var(--pgm-sys-spacing-16) clamp(24px, 12vw, 216px) 44px;
  width: 100%;

  > section {
    box-sizing: border-box;
    min-width: 0;
  }
}

.footerLogo {
  display: block;
  flex-shrink: 0;
  height: 60px;
  object-fit: contain;
  width: 277px;
}

.footerSection1 {
  display: flex;
  flex-direction: column;

  .footerLogo {
    margin-bottom: 40px;
  }

  h4 {
    margin: 0 0 8px;
  }
}

.footerAddressLink {
  white-space: pre-line;
}

.footerSection2 {
  display: flex;
  flex-direction: column;
  gap: 16px;

  h4,
  p {
    margin: 0;
  }
}

.footerSchedule {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.footerScheduleGroup {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.footerSection3 {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;

  h4,
  p {
    margin: 0;
  }

  h4 {
    margin-bottom: 8px;
    white-space: pre-line;
  }
}

.footerContactDescription,
.footerContactLink {
  margin-bottom: 8px;
  white-space: pre-line;
}

.footerContactLink,
.footerContactButton {
  align-self: flex-start;
}

.footerSection3 .footerContactPhone {
  margin-bottom: 40px;
}

.footerSection3 .footerContactHelp {
  margin-bottom: 24px;
}

.footerCredits {
  align-items: center;
  background-color: var(--pgm-sys-color-brand-secondary);
  display: flex;
  flex: 0 0 36px;
  justify-content: center;
  min-width: 0;
  text-align: center;

  span {
    color: var(--pgm-sys-color-on-primary);
    display: -webkit-box;
    max-width: 100%;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
}

.footerSidebar {
  align-self: stretch;
  display: flex;
  flex: 0 0 48px;
  flex-direction: column;
  gap: 2px;
  width: 48px;
}

.footerSidebarSection1 {
  background-color: var(--pgm-sys-color-brand-tertiary);
  flex: 0 0 64px;
}

.footerSidebarSection2 {
  background-color: var(--pgm-sys-color-brand-primary);
  flex: 1 1 256px;
}

.footerSidebarSection3 {
  background-color: var(--pgm-sys-color-brand-secondary);
  flex: 0 0 120px;
}

.footerSidebarBackground {
  background-color: var(--pgm-sys-color-brand-background);
  height: 24px;
  width: 50%;
}

.footerSidebarRight .footerSidebarBackground {
  margin-left: auto;
}

@media (max-width: 599.98px) {
  .footerSidebar {
    flex: 0 0 var(--pgm-sys-spacing-4);
    width: var(--pgm-sys-spacing-4);
  }
}

@media (max-width: 991.98px) {
  .footerLogo {
    height: auto;
    max-width: 100%;
  }
}

